import { render, staticRenderFns } from "./LayoutEmpty.vue?vue&type=template&id=9db3e30a&scoped=true"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db3e30a",
  null
  
)

export default component.exports